import { useQuery } from '@apollo/client';
import { Badge, Heading, NavigationTabs, NavigationTabsItem, Stack } from '@sixfold/common-ui';
import { Route, Routes as RouterRoutes, Navigate } from 'react-router';

import { TelematicsIntegrationsContainer } from './integrations_container';
import { TelematicsProviderContainer } from './provider_container';
import { TelematicsProvidersContainer } from './providers_container';
import { TelematicsCountsQuery } from '../../lib/graphql';
import { Routes } from '../../routes';
import { telematicsCountsQuery } from '../graphql';

const TelematicsLayout = () => {
  const result = useQuery<TelematicsCountsQuery>(telematicsCountsQuery);

  return (
    <Stack direction="column" gap="medium">
      <Heading size="large">Telematics</Heading>
      <NavigationTabs>
        <NavigationTabsItem
          href={Routes.TelematicsProviders.generatePath({})}
          end={
            result.loading ? undefined : (
              <Badge size="small" kind="neutral">
                {result.data?.telematicsProvidersV2?.count ?? 0}
              </Badge>
            )
          }>
          Providers
        </NavigationTabsItem>
        <NavigationTabsItem
          href={Routes.TelematicIntegrations.generatePath({})}
          end={
            result.loading ? undefined : (
              <Badge size="small" kind="neutral">
                {result.data?.telematicsIntegrations?.count ?? 0}
              </Badge>
            )
          }>
          Integrations
        </NavigationTabsItem>
      </NavigationTabs>
      <RouterRoutes>
        <Route path={Routes.TelematicsProvider.relativePath} element={<TelematicsProviderContainer />} />
        <Route path={Routes.TelematicsProviders.relativePath} element={<TelematicsProvidersContainer />} />
        <Route path={Routes.TelematicIntegrations.relativePath} element={<TelematicsIntegrationsContainer />} />
        <Route index element={<Navigate to={Routes.TelematicsProviders.generatePath({})} replace />} />
      </RouterRoutes>
    </Stack>
  );
};

export const TelematicsContainer = () => {
  return <TelematicsLayout />;
};
